export default "__VITE_ASSET__jX44mCUO__"